// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var LogicForm$ReactHooksTemplate = require("./LogicForm.res.js");

function TicketGenerationLogic(props) {
  var saveTicketLogics = props.saveTicketLogics;
  var createTicketLogic = props.createTicketLogic;
  var removeTicketLogics = props.removeTicketLogics;
  var updateTicketLogics = props.updateTicketLogics;
  var ticketLogics = props.ticketLogics;
  var survey = props.survey;
  var match = Survey$ReactHooksTemplate.id(survey);
  return JsxRuntime.jsx("div", {
              children: match !== undefined ? JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Ticket Generation Logics",
                                      className: "text-lg font-semibold"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.plusCircle
                                                    }),
                                                "Add Logic"
                                              ],
                                              className: "flex bg-ghostwhite border border-gray-400 shadow-inner rounded py-2\n                   px-3 text-xs font-normal cursor-pointer w-40 justify-center items-center",
                                              onClick: (function (param) {
                                                  Curry._1(createTicketLogic, undefined);
                                                })
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: "Save",
                                              className: props.edited ? "bg-pigmentblue hover:bg-cetaceanblue px-3 py-2 rounded text-xs text-white font-normal w-40 flex justify-center items-center" : "bg-pigmentblue hover:bg-cetaceanblue px-3 py-2 rounded text-xs text-white font-normal w-40 flex justify-center items-center disabled-input",
                                              onClick: (function (param) {
                                                  Curry._1(saveTicketLogics, undefined);
                                                })
                                            })
                                      ],
                                      className: "flex gap-4"
                                    })
                              ],
                              className: "flex justify-between items-center mb-5-px"
                            }),
                        ticketLogics ? $$Array.of_list(Belt_List.mapWithIndex(ticketLogics, (function (index, y) {
                                      return JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx(LogicForm$ReactHooksTemplate.make, {
                                                              survey: survey,
                                                              logic: y,
                                                              updateLogic: Curry._1(updateTicketLogics, index),
                                                              deleteLogic: removeTicketLogics
                                                            }),
                                                        className: "flex-col items-center"
                                                      }),
                                                  className: "bg-ghostwhiteblue w-full rounded p-4"
                                                }, String(index));
                                    }))) : JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("span", {
                                                children: "🗂️",
                                                className: "text-2xl text-gray-400 mr-3"
                                              }),
                                          "No logics created yet"
                                        ],
                                        className: "text-lg text-gray-900 text-lg mb-2"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: "Click 'Add Logic' to create your first logic",
                                        className: "text-gray-500 text-sm"
                                      })
                                ],
                                className: "flex flex-col items-center justify-center py-12 border-2 border-dashed border-gray-300 rounded-lg"
                              })
                      ],
                      className: "flex flex-col gap-4"
                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {
                      children: "No survey selected. Kindly select a survey"
                    }),
              className: "flex flex-col overflow-y-auto"
            });
}

var make = TicketGenerationLogic;

exports.make = make;
/* react/jsx-runtime Not a pure module */
